import React from 'react';
import {
  PostListItem,
} from '.';
import './PostList.scss';

const PostList = (props) => {
  const {
    posts,
    siteMetadata,
  } = props;
  const { blogSlug } = siteMetadata;
  if (!posts || posts.length < 1) return null;
  return (
    <section className="post-list">
      <div className="posts">
        {posts.map(post => (
          <PostListItem
            key={post.uid}
            blogSlug={blogSlug}
            {...post}
          />
        ))}
      </div>
    </section>
  );
};

export default PostList;
